/** Placement of trackside furniture that must stay off the riding surface of the lap. */
import { Level } from './level';

/** Clear space furniture keeps from the lap's edge, metres. */
export const FURNITURE_CLEARANCE = 1;

/** True when (x, z) is at least `clearance` metres outside the lap's riding surface (anywhere on the lap). */
export function offLap(level: Level, x: number, z: number, clearance = FURNITURE_CLEARANCE): boolean {
  if (!level.line) return true;
  const c = level.line.closest(x, z);
  return Math.abs(c.d) >= level.halfWidthAt[c.index]! + clearance;
}

/**
 * Course-tape stakes every `every` metres, `offset` metres outside both edges. A stake that would stand on another
 * part of the lap (inside hairpins, where two legs run close) is null: the tape breaks there.
 */
export function courseTapeStakes(level: Level, offset = 1.5, every = 6): ({ x: number; z: number } | null)[][] | null {
  const line = level.line;
  if (!line) return null;
  const n = Math.floor(line.length / every);
  return [-1, 1].map((side) => {
    const out: ({ x: number; z: number } | null)[] = [];
    for (let i = 0; i < n; i++) {
      const s = i * every, p = line.pointAt(s), t = line.tangentAt(s);
      const off = level.halfWidthAt[Math.round(s / line.step) % line.count]! + offset;
      const x = p.x - t.z * off * side, z = p.z + t.x * off * side;
      out.push(offLap(level, x, z) ? { x, z } : null);
    }
    return out;
  });
}
